import { axiosInstance } from '@services/base-service';

const coreOperationsUri = '/merchant/bff/core-operations';

export const getAccountData = (id) =>
  axiosInstance.getInstance().get(`${coreOperationsUri}/merchant/bank_account/${id}`);

export const deleteBankAccount = (bankAccountId) =>
  axiosInstance.getInstance().delete(`${coreOperationsUri}/merchant/bank_account/${bankAccountId}`);

export const createBankAccount = (payload) =>
  axiosInstance.getInstance().post(`${coreOperationsUri}/merchant/bank_account`, {
    payload,
  });

export const updateBankAccount = ({ bankAccountId, payload }) =>
  axiosInstance.getInstance().put(`${coreOperationsUri}/merchant/bank_account/${bankAccountId}`, {
    payload,
  });

export const updateAutoCashout = () =>
  axiosInstance.getInstance().post(`${coreOperationsUri}/merchant/bank_account/update/recurrent`);
